import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import styles from "./DefaultErrorElement.module.css";

export function DefaultErrorElement() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <div id="error-page" className={styles["error-page"]}>
        <h1>Oops! {error.status}</h1>
        <p>{error.statusText}</p>
        {error.data?.message && (
          <p>
            <i>{error.data.message}</i>
          </p>
        )}
      </div>
    );
  }
  if (error instanceof Error) {
    return (
      <div id="error-page" className={styles["error-page"]}>
        <h1>Oops! Unexpected Error</h1>
        <p>Something went wrong.</p>
        <p>
          <i>{error.message}</i>
        </p>
      </div>
    );
  }

  return (
    <div id="error-page" className={styles["error-page"]}>
      <h1>Oops! Unexpected Error</h1>
      <p>Something went wrong.</p>
      <p>
        <i>
          An unknown error occurred. Please contact your system administrator.
        </i>
      </p>
    </div>
  );
}
